import React from 'react';
import { SectionTitle } from './SectionTitle';
import { modules } from '../data/salesCopy';
export function ModulesSection() {
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-100" data-mp="1nt3dlzbwnw19">
      <div className="mx-auto max-w-3xl" data-id="element-101" data-mp="1iv1p2yvpn4ie">
        <SectionTitle data-id="element-102" data-mp="1ivurxorjt9v9">Ce qui est inclus</SectionTitle>

        <div className="mt-5 space-y-2.5" data-id="element-103" data-mp="1dx07kidxnd91">
          {modules.map(mod => <article key={mod.n} className="overflow-hidden rounded-lg border border-brand-sand bg-white shadow-sm" data-id="element-104" data-mp="2bjyyechy1qz0">
              <header className="flex items-center gap-2 bg-brand-sage px-3 py-2 sm:px-4" data-id="element-105" data-mp="26lxg3tscdvol">
                <span className="shrink-0 rounded bg-brand-gold px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-white" data-id="element-106" data-mp="21kht3w6ltf3k">
                  Module {mod.n}
                </span>
                <h3 className="font-serif text-base font-bold uppercase leading-tight text-white sm:text-xl" data-id="element-107" data-mp="q8h1m9icvck4">
                  {mod.title}
                </h3>
              </header>

              <div className="space-y-2 p-3 sm:p-4" data-id="element-108" data-mp="1iwa4uabn8vpw">
                {mod.paras.map(p => <p key={p} className="text-[12.5px] font-medium leading-snug text-brand-brown/85 sm:text-[13.5px]" data-id="element-109" data-mp="1nta9cgsuhqew">
                    {p}
                  </p>)}
                <p className="border-t border-brand-sand pt-2 text-[12.5px] font-bold uppercase leading-snug tracking-wide text-brand-taupe sm:text-[13.5px]" data-id="element-110" data-mp="1dy8jtjunqmbs">
                  {mod.close}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}